import styled from "styled-components";

export const CheckboxWrapper = styled.label`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  color: ${({ theme }) => theme.colors.default[400]};
  cursor: pointer;
`;

export const CheckboxContainer = styled.div`
  position: relative;
  width: fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
`;

export const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  position: absolute;
  opacity: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;
`;

export const CheckboxLabel = styled.p`
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;

  & > a {
    text-decoration-line: underline;
    cursor: pointer;
  }
`;
